import { noop } from "../../../common/function";

/**
 *
 *
 *
 *
 */
export const baseLocation: Location = import.meta.env.SSR
  ? {
      assign: noop,
      reload: noop,
      replace: noop,
      href: "http:/*     */
      origin: "https:/*    */
      protocol: "https",
      host: "host",
      hostname: "host",
      port: "",
      pathname: "/",
      search: "",
      hash: "",
      ancestorOrigins: {} as DOMStringList,
    }
  : location;
